/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import TIME_OUTS from 'modules/common/constants/time-outs';

/**
 * System Maintenance feature related request structures are defined here
 */
const API = {
  POST_SYNC_DATABRICKS_DATA: {
    path: '/sync-databricks-data?:query',
    method: 'POST',
    timeout: TIME_OUTS.LONG_REQUEST_TIMEOUT_MS,
  },
  POST_SYNC_CURRENCY_DATA: {
    path: '/sync-currency-data',
    method: 'POST',
    timeout: TIME_OUTS.LONG_REQUEST_TIMEOUT_MS,
  },
  POST_SYNC_BREAKDOWN_DATA: {
    path: '/sync-breakdown-data',
    method: 'POST',
    timeout: TIME_OUTS.LONG_REQUEST_TIMEOUT_MS,
  },
  GET_SYSTEM_INFORMATION: {
    path: '/system-information',
    method: 'GET',
  },
  POST_SYSTEM_INFORMATION: {
    path: '/system-information',
    method: 'POST',
  },
  PATCH_SYSTEM_INFORMATION: {
    path: '/system-information/:systemInformationId',
    method: 'PATCH',
  },
};
//
export default API;
